<script>
  import TestSection from "./TestSection.svelte";
  import * as testContents from "../configs/testItems.json";
  export let sections = testContents.default;
  //console.log(sections);

  import Store from "../stores/Store";

  import { meetsRequirements, sum } from "../global.js";

  let answers;
  Store.subscribe((data) => {
    answers = data;
  });

  export function scores(answersJSON = answers) {
    const returnDict = {};
    for (let section of sections) {
      returnDict[section.heading] = section.items.reduce(
        (partialSum, ite) =>
          partialSum +
          ite.points *
            (answersJSON[ite.ident] ?? 0) *
            (ite.prerequisitesPolicy
              ? meetsRequirements(answersJSON, ite.prerequisitesPolicy)
              : 1),
        0
      );
    }
    //console.log(returnDict);
    return returnDict;
  }

  const totalNumQuestions = sum(
    sections.map((section) => section.items.length)
  );
</script>

<main>
  <div class="alert alert-light shadow" role="alert">
    {totalNumQuestions} Items
  </div>
  {#each sections as sect}
    <TestSection heading={sect.heading} items={sect.items} color={sect.color} />
  {/each}
</main>
